import Axios from "axios";

const getSiteVisitReportsAwaitingApproval = async token =>
  await Axios.get(`${window.API}/site-visit/unapproved`, {
    headers: { Authorization: `Bearer ${token}` },
  });

export { getSiteVisitReportsAwaitingApproval };
